import { Link } from 'react-router-dom';
import { type DailySummarySectionDto } from '@/app/models/DailySummarySectionDto';
import { getSummaryLinkPath } from '../core/_utils';

type DailySummarySectionsProps = {
  sections: DailySummarySectionDto[];
  /** O link da linha leva a outra tela: quem mostra o resumo se fecha. */
  onNavigate: () => void;
};

const DailySummarySections = ({ sections, onNavigate }: DailySummarySectionsProps) => (
  <div className="d-flex flex-column gap-3">
    {sections.map((section) => (
      <div key={section.point_of_sale_id ?? 'geral'}>
        <div className="fw-bold text-gray-800 fs-7">{section.point_of_sale_name}</div>
        {section.lines.map((line) => (
          <div key={line.type.value} className="text-muted fs-7">
            {line.text}
            {line.link ? (
              <Link
                className="position-relative z-index-2 fw-semibold ms-2"
                to={getSummaryLinkPath(line.link)}
                onClick={onNavigate}
              >
                Gerar picklist
              </Link>
            ) : null}
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default DailySummarySections;
